import auth from '../../../api/auth'


export default {

  Now_yyyy_MM_dd() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  Date_yyyy_MM_dd(val) {
    let today = new Date(val);
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  http_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/Coper/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        
      }
    })
  },

  api_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),

      }
    })
  },

  api_post_FileDownload(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
      },responseType: "arraybuffer"
    })
  },

  // Indirilen veriyi tarayiciya dosya olarak verir.
  //
  // createObjectURL urettigi adresi tarayici KENDILIGINDEN serbest
  // birakmaz; sayfa yenilenene kadar veri bellekte kalir. Buyuk aktarim
  // dosyalarinda (Logo XML'i ~3 MB) art arda indirmede birikiyordu, bu
  // yuzden indirme basladiktan sonra adres geri veriliyor.
  //
  // Gecikme gerekli: click() indirmeyi eszamanli baslatmiyor, adres hemen
  // iptal edilirse bazi tarayicilarda dosya bos iniyor.
  CreateDownloadLink(response,fileName){
    let contentType = response.headers.get("Content-Type");

    let blob = new Blob([response.data], {
      type: contentType
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    setTimeout(function () { window.URL.revokeObjectURL(link.href); }, 5000);
  },

  OpenPdfInNewTab(response) {
    let blob = new Blob([response.data], { type: 'application/pdf' });
    let blobUrl = window.URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  },

  downloadTransferVoucherPdf(owner, pnrNo, lang, showPrice) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (!lang) {
      lang = 'tr';
    }
    if (showPrice === undefined || showPrice === null) {
      showPrice = false;
    }

    return owner.$http.post(
      auth.API_URL +
        `api/Coper/TransferListesiVoucherDownload?pnrNo=${encodeURIComponent(pnrNo)}` +
        `&lang=${encodeURIComponent(lang)}` +
        `&showPrice=${encodeURIComponent(showPrice)}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
          'CariSirketNo': credentials.SirketKodu.toString(),
          'CoperSirketNo': credentials.CoperSirketNo.toString(),
          'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        },
        responseType: "arraybuffer",
      }
    ).then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
      window.URL.revokeObjectURL(blobUrl);
    });
  },

  downloadHotelVoucherPdf(owner, pnrNo, lang) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (!lang) {
      lang = 'tr';
    }

    return owner.$http.post(
      auth.API_URL +
        `api/Coper/VoucherPdfDownload?pnrNo=${encodeURIComponent(pnrNo)}` +
        `&lang=${encodeURIComponent(lang)}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
          'CariSirketNo': credentials.SirketKodu.toString(),
          'CoperSirketNo': credentials.CoperSirketNo.toString(),
          'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        },
        responseType: "arraybuffer",
      }
    ).then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
      window.URL.revokeObjectURL(blobUrl);
    });
  },

  api_file_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        'Content-Type': 'multipart/form-data'

      }
    })
  },


  api_file_post2(owner, url, files, prm) {

    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let file = files[i];
      formData.append('files[' + i + ']', file);
    }

    if (prm==undefined){
      prm={}
    }

    formData.append('jsondata',JSON.stringify(prm))

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, formData, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        'Content-Type': 'multipart/form-data'

      }
    })
  },


   responseToStatus(response) {
    let status = this.NewSatatus();
    if (response.status === 0) {
      status.text = this.$t('The-web-service-is-out-of-service-Please-try-again-later.');
      status.show = true;
      status.loading = false;
    } else {
      status.text = response.statusText
      if((response.body != null) && (response.body.ExceptionMessage != null))
      {
        status.text = response.body.ExceptionMessage;
      }
      status.show = true;
      status.loading = false;
      //let enc = new TextDecoder("utf-8");
      //console.log(enc.decode(response.body));
    }
    return status
  },


  NewSatatus() {
    return {
      show: false,
      text: "",
      loading: false,
    }
  },

  /**
   * Basarisiz bir istekten kullaniciya gosterilecek mesaji cikarir.
   *
   * Onceden her hata "Service Unavailable" diye gosteriliyordu; sunucunun
   * asil aciklamasi (orn. "Secilen aralikta aktarilacak fatura bulunamadi")
   * kayboluyordu. ArkmanNext is kurali hatalarini duz metin govdeyle
   * donduruyor, aradigimiz sey orada.
   *
   * `ceviri` = i18n fonksiyonu (genelde `this.$t.bind(this)`). Verilmezse
   * anahtar oldugu gibi doner; bilesen disindan da cagrilabilsin diye.
   */
  HataMesajiCoz(response, ceviri) {
    var $t = typeof ceviri === "function" ? ceviri : function (k) { return k; };

    // status 0 = baglanti kurulamadi; sunucudan gelen bir mesaj yok.
    if (!response || response.status === 0) return $t("Service-Unavailable");

    var govde = response.body !== undefined ? response.body : response.data;

    if (typeof govde === "string" && govde.trim() !== "") {
      return govde.trim().slice(0, 300);
    }

    // Indirme cagrilari responseType "arraybuffer" kullaniyor; hata govdesi de
    // ikili geliyor. Sunucu text/plain UTF-8 gonderdigi icin cozulebilir.
    // "instanceof ArrayBuffer" KULLANILMIYOR: govde baska bir realm'den gelirse
    // (iframe, test ortami) yanlislikla false doner. toString etiketi ve
    // ArrayBuffer.isView ikisi de realm'den bagimsiz calisir.
    var tur = Object.prototype.toString.call(govde);
    if (tur === "[object ArrayBuffer]" || ArrayBuffer.isView(govde)) {
      try {
        var ikili = tur === "[object ArrayBuffer]" ? new Uint8Array(govde) : govde;
        var cozulen = new TextDecoder("utf-8").decode(ikili).trim();
        if (cozulen !== "") return cozulen.slice(0, 300);
      } catch (e) {
        // TextDecoder yoksa ya da icerik metin degilse sessizce gecilir.
      }
    }

    if (govde && typeof govde === "object") {
      var m = govde.Message || govde.message || govde.ExceptionMessage;
      if (m) return String(m).slice(0, 300);
    }

    // Govde okunamadi (orn. blob indirmede); en azindan durum kodunu goster.
    return (
      (response.status || "") +
      " " +
      (response.statusText || $t("Service-Unavailable"))
    ).trim();
  }





}